/* ================= Raycasting and advanced Click Wheel gestures ================= */
var TH0=0.0, PH0=1.57;
var BASE_VIEW_RADIUS=14.0, BASE_MIN_VIEW_RADIUS=10.2, BASE_MAX_VIEW_RADIUS=14.0;
var R0=BASE_VIEW_RADIUS, MIN_VIEW_RADIUS=BASE_MIN_VIEW_RADIUS, MAX_VIEW_RADIUS=BASE_MAX_VIEW_RADIUS;
var theta=TH0, phi=PH0, radius=R0;
var tTheta=TH0, tPhi=PH0, tRadius=R0;
var auto=false, lastInteract=0;

var el = renderer.domElement.closest('.hero__product') || renderer.domElement;
var ptrs=new Map(), lastPinch=null;
var lastBodyTapTime=0, lastBodyTapX=0, lastBodyTapY=0;
var suppressMobileDblClickUntil=0;
function interact(){
  lastInteract=performance.now();
  window.repodUserInteracted = true;
}
function repodUsesMobileControls(){
  return (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) || window.innerWidth < 768;
}
function repodUsesFixedFrontView(){
  return !!(
    renderer &&
    renderer.domElement &&
    renderer.domElement.closest('[data-repod-experience]')
  );
}
function toggleBodyZoom(){
  var closeThreshold=MIN_VIEW_RADIUS+(R0-MIN_VIEW_RADIUS)*0.18;
  tRadius=(tRadius<=closeThreshold || radius<=closeThreshold) ? R0 : MIN_VIEW_RADIUS;
  interact();
}
function isBodyDoubleTap(clientX,clientY,now){
  var tapGap=now-lastBodyTapTime;
  var tapDist=Math.hypot(clientX-lastBodyTapX, clientY-lastBodyTapY);
  if(tapGap>40 && tapGap<420 && tapDist<42){
    lastBodyTapTime=0;
    return true;
  }
  lastBodyTapTime=now;
  lastBodyTapX=clientX;
  lastBodyTapY=clientY;
  return false;
}

function updateViewRadiusBounds(){
  if(!renderer || !renderer.domElement) return;
  var canvasH=renderer.domElement.clientHeight||0;
  var product=renderer.domElement.closest('.hero__product');
  var productH=product ? product.getBoundingClientRect().height : 0;
  if(!canvasH || !productH) return;
  var oldR0=R0;
  var wasAtDefault=Math.abs(tRadius-oldR0)<0.08 && Math.abs(radius-oldR0)<0.08;
  var baseCanvasH=productH+120; // Original -60px model-container inset on top and bottom.
  var scale=clamp(canvasH/baseCanvasH,1,1.42);
  R0=BASE_VIEW_RADIUS*scale;
  MIN_VIEW_RADIUS=BASE_MIN_VIEW_RADIUS*scale;
  MAX_VIEW_RADIUS=BASE_MAX_VIEW_RADIUS*scale;
  if(wasAtDefault){
    radius=R0;
    tRadius=R0;
  }else{
    radius=clamp(radius,MIN_VIEW_RADIUS,MAX_VIEW_RADIUS);
    tRadius=clamp(tRadius,MIN_VIEW_RADIUS,MAX_VIEW_RADIUS);
  }
}

var raycaster = new THREE.Raycaster();
var mouse = new THREE.Vector2();
var isDraggingWheel = false;
var wheelGestureMode = 'ring';   // ring | swipe
var lastDragAngle = 0;   // previous finger angle relative to the wheel center
var lastDragRadius = 0;
var lastDragOnRing = false;
var tapCand = null;      // screen / center-key tap candidate recorded on press and confirmed on release

var WHEEL_RING_INNER = 0.58;
var WHEEL_RING_OUTER = 1.425;
var WHEEL_MAX_STEP = 0.58;          // large jumps are usually a straight chord across the wheel
var WHEEL_MAX_RADIAL_SHARE = 0.72;  // radial swipes should not act like circular wheel turns
var SCREEN_SWIPE_MIN = 54;
var SCREEN_SWIPE_RATIO = 1.15;

function isSameOrChild(obj,target){
  if(!obj || !target) return false;
  for(var o=obj;o;o=o.parent){
    if(o===target) return true;
  }
  return false;
}
function isInvisibleHit(hit){
  var mat=hit && hit.object && hit.object.material;
  if(!mat) return false;
  var mats=Array.isArray(mat) ? mat : [mat];
  for(var i=0;i<mats.length;i++){
    if(!mats[i].transparent || mats[i].opacity>0.01) return false;
  }
  return true;
}
function firstUsableHit(intersects){
  for(var i=0;i<intersects.length;i++){
    if(!isInvisibleHit(intersects[i])) return intersects[i];
  }
  return null;
}
function isWheelFacingCamera(){
  if(!wheelG || !camera) return false;
  var wp=new THREE.Vector3();
  var normal=new THREE.Vector3(0,0,1);
  wheelG.getWorldPosition(wp);
  normal.transformDirection(wheelG.matrixWorld);
  return normal.dot(new THREE.Vector3().subVectors(camera.position,wp).normalize()) > 0.18;
}
function isWheelHitObject(obj){
  if(!obj || obj===centerBtn || obj===screen) return false;
  return typeof donut!=='undefined' && isSameOrChild(obj,donut);
}
function isVisibleWheelRingHit(hit){
  return !!(hit && isWheelFacingCamera() && isWheelHitObject(hit.object));
}
function isTopHitObject(hit,obj){
  return !!(hit && isSameOrChild(hit.object,obj));
}

function wheelCenterOnScreen(){
  var wp=new THREE.Vector3();
  wheelG.getWorldPosition(wp);
  var sp=wp.project(camera);
  var rect = renderer.domElement.getBoundingClientRect();
  return {
    x: rect.left + (sp.x+1)*rect.width/2,
    y: rect.top + (-sp.y+1)*rect.height/2
  };
}
function wheelLocalToScreen(x,y){
  var wp=new THREE.Vector3(x,y,0);
  wheelG.localToWorld(wp);
  var sp=wp.project(camera);
  var rect = renderer.domElement.getBoundingClientRect();
  return {
    x: rect.left + (sp.x+1)*rect.width/2,
    y: rect.top + (-sp.y+1)*rect.height/2
  };
}
function wheelScreenScaleAt(frame,a){
  var ca=Math.cos(a), sa=Math.sin(a);
  var sx=ca*frame.ux.x + sa*frame.uy.x;
  var sy=ca*frame.ux.y + sa*frame.uy.y;
  return Math.max(1, Math.hypot(sx,sy));
}
function wheelRingState(clientX,clientY){
  var c=wheelCenterOnScreen();
  var xp=wheelLocalToScreen(1,0);
  var yp=wheelLocalToScreen(0,1);
  var vx=clientX-c.x, vy=clientY-c.y;
  var a=Math.atan2(vy,vx);
  var r=Math.hypot(vx,vy);
  var scale=wheelScreenScaleAt({
    ux:{x:xp.x-c.x,y:xp.y-c.y},
    uy:{x:yp.x-c.x,y:yp.y-c.y}
  },a);
  var pad=Math.max(8,scale*0.06);
  return {
    angle:a,
    radius:r,
    scale:scale,
    onRing:r>=WHEEL_RING_INNER*scale-pad && r<=WHEEL_RING_OUTER*scale+pad
  };
}
function isCircularWheelMove(dx,dy,dAngle,prevRadius,radius){
  var move=Math.hypot(dx,dy);
  if(move<0.5) return false;
  if(Math.abs(dAngle)>WHEEL_MAX_STEP) return false;
  return Math.abs(radius-prevRadius)<=move*WHEEL_MAX_RADIAL_SHARE;
}
function isWheelSwipeStart(clientX,clientY,ws){
  return false;
}
function normAngle(a){
  while(a> Math.PI) a-=Math.PI*2;
  while(a<-Math.PI) a+=Math.PI*2;
  return a;
}
function beginWheelDrag(ws){
  isDraggingWheel = true;
  wheelGestureMode = 'ring';
  auto = false;
  if(btnSpin) btnSpin.classList.remove('on');
  if(repodUsesFixedFrontView()) audioInit();
  dragAccum = 0;
  lastDragAngle = ws.angle;
  lastDragRadius = ws.radius;
  lastDragOnRing = true;
  tapCand = null;
}
function beginWheelSwipe(ws){
  beginWheelDrag(ws);
  wheelGestureMode = 'swipe';
  lastDragOnRing = false;
}
function endWheelDrag(){
  if(!isDraggingWheel) return;
  isDraggingWheel=false;
  lastDragOnRing=false;
  lastDragRadius=0;
  if(repodUsesFixedFrontView()) APP.onRelease();
  dragAccum=0;
}

el.addEventListener('pointerdown',function(e){
  var rect = renderer.domElement.getBoundingClientRect();
  mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
  mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
  raycaster.setFromCamera(mouse, camera);

  var intersects = raycaster.intersectObjects(device.children, true);
  var topHit = firstUsableHit(intersects);
  var ws = wheelRingState(e.clientX,e.clientY);

  var hitDevice = !!topHit;
  var hitWheelRing = ws.onRing && isVisibleWheelRingHit(topHit);
  var screenHit = isTopHitObject(topHit,screen) ? topHit : null;
  var centerHit = isTopHitObject(topHit,centerBtn) ? topHit : null;
  var wheelSwipeStart = isWheelSwipeStart(e.clientX,e.clientY,ws);
  var fixedFrontView = repodUsesFixedFrontView();
  if(!fixedFrontView){
    // In the Banner, the click wheel, screen, and center key are all treated as
    // ordinary model surfaces. Only the experience section enables their input.
    hitWheelRing=false;
    wheelSwipeStart=false;
    screenHit=null;
    centerHit=null;
  }
  var mobileBodyTap = !fixedFrontView && repodUsesMobileControls() && !hitWheelRing && !screenHit && !centerHit;
  var interactiveControlHit = hitWheelRing || screenHit || centerHit || wheelSwipeStart;

  if (fixedFrontView && !interactiveControlHit) {
    return; // The secondary section keeps the body fixed while preserving wheel and screen input.
  }

  if (!hitDevice && !hitWheelRing && !mobileBodyTap && !wheelSwipeStart) {
    return; // Touch outside the product, let browser scroll naturally
  }

  el.setPointerCapture(e.pointerId);
  el.style.cursor = 'grabbing';
  ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY,sx:e.clientX,sy:e.clientY,st:performance.now(),screen:false,body:false,passive:!hitDevice&&!hitWheelRing&&!wheelSwipeStart});
  interact();

  if (ptrs.size > 1) {           // second finger starts a two-finger zoom
    endWheelDrag();
    tapCand = null;
    return;
  }

  if (centerHit) {
    var cp = ptrs.get(e.pointerId);
    if (cp) cp.ignore = true;
    isDraggingWheel = false;
    tapCand = null;
    return;
  }
  if (hitWheelRing) {
    beginWheelDrag(ws);
  } else if (wheelSwipeStart) {
    beginWheelSwipe(ws);
  } else {
    isDraggingWheel = false;
    if (screenHit && screenHit.uv) {
      var sp = ptrs.get(e.pointerId);
      if (sp) sp.screen = true;
      var uv = screenHit.uv;   // screen tap converted to 512x512 canvas coordinates
      tapCand = { x:e.clientX, y:e.clientY, t:performance.now(),
                  px:uv.x*512, py:(1-uv.y)*512 };
    } else {
      var bp = ptrs.get(e.pointerId);
      if (bp) bp.body = true;
      if (mobileBodyTap && isBodyDoubleTap(e.clientX,e.clientY,performance.now())) {
        toggleBodyZoom();
        suppressMobileDblClickUntil=performance.now()+520;
        bp.ignore = true;
      }
      tapCand = null;
    }
  }
});

el.addEventListener('pointermove',function(e){
  if(ptrs.has(e.pointerId)){
    var p=ptrs.get(e.pointerId);
    var dx=e.clientX-p.x, dy=e.clientY-p.y;
    p.x=e.clientX; p.y=e.clientY;
    if (p.ignore || p.passive) return;



    if (isDraggingWheel) {
      var ws = wheelRingState(e.clientX,e.clientY);
      if (wheelGestureMode === 'swipe') {
        var dragScale = repodUsesMobileControls() ? 1.18 : 1;
        if (Math.abs(dx) > 0.5 && (Math.abs(dx) >= Math.abs(dy) * 0.45 || Math.abs(e.clientX - p.sx) > 16)) {
          onWheelDelta(dx * 0.0065 * dragScale);
        }
      } else {
        // Circular gesture: angle delta is forwarded to the active scene.
        var d = normAngle(ws.angle - lastDragAngle);
        if (ws.onRing && lastDragOnRing && isCircularWheelMove(dx,dy,d,lastDragRadius,ws.radius)) {
          onWheelDelta(d);
        }
        lastDragAngle = ws.angle;
        lastDragRadius = ws.radius;
        lastDragOnRing = ws.onRing;
      }
      interact();
    } else if (p.screen) {
      interact();
    } else {
      if(ptrs.size===1){
        var dragScale=repodUsesMobileControls()?1.28:1;
        tTheta-=dx*0.006*dragScale;
        tPhi=clamp(tPhi-dy*0.005*dragScale,0.25,2.6);
      }else if(ptrs.size===2){
        var v=Array.from(ptrs.values());
        var d2=Math.hypot(v[0].x-v[1].x,v[0].y-v[1].y);
        if(lastPinch){
          var pinchRatio=lastPinch/d2;
          if(repodUsesMobileControls()) pinchRatio=1+(pinchRatio-1)*1.12;
          tRadius=clamp(tRadius*pinchRatio,MIN_VIEW_RADIUS,MAX_VIEW_RADIUS);
        }
        lastPinch=d2;
      }
      interact();
    }
  } else {
    var rect = renderer.domElement.getBoundingClientRect();
    mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);
    var intersects = raycaster.intersectObjects(device.children, true);
    var topHit = firstUsableHit(intersects);
    var ho = topHit ? topHit.object : null;
    var sceneControls=repodUsesFixedFrontView();
    var hoverRing = sceneControls && wheelRingState(e.clientX,e.clientY).onRing && isVisibleWheelRingHit(topHit);
    if (sceneControls && isTopHitObject(topHit,centerBtn)) {
      el.style.cursor = 'default';
    } else if (hoverRing || (sceneControls && isTopHitObject(topHit,screen))) {
      el.style.cursor = 'pointer';
    } else if (ho) {
      el.style.cursor = repodUsesFixedFrontView() ? 'default' : 'grab';
    } else {
      el.style.cursor = 'default';
    }
  }
});

function endPtr(e,isUp){
  var p=ptrs.get(e.pointerId);
  ptrs.delete(e.pointerId);
  lastPinch=null;
  endWheelDrag();
  wheelGestureMode = 'ring';
  if (el) el.style.cursor = 'default';
  if(isUp && repodUsesFixedFrontView() && p && p.screen && APP===gameApp && typeof switchGame === 'function'){
    var sx=e.clientX-p.sx, sy=e.clientY-p.sy;
    if(Math.abs(sx)>SCREEN_SWIPE_MIN && Math.abs(sx)>Math.abs(sy)*SCREEN_SWIPE_RATIO){
      switchGame(sx<0?1:-1);
      tapCand=null;
      return;
    }
  }
  if(isUp && repodUsesFixedFrontView() && tapCand){
    var moved=Math.hypot(e.clientX-tapCand.x, e.clientY-tapCand.y);
    if(moved<9 && performance.now()-tapCand.t<520){   // short hold with little movement counts as a tap
      audioInit();
      APP.onTap(tapCand.px, tapCand.py);
      interact();
    }
  }
  tapCand=null;
}
el.addEventListener('pointerup',function(e){ endPtr(e,true); });
el.addEventListener('pointercancel',function(e){ endPtr(e,false); });
el.addEventListener('touchmove', function(e) {
  if (ptrs.size > 0) {
    var shouldPrevent=false;
    ptrs.forEach(function(p){
      if(!p.passive) shouldPrevent=true;
    });
    if(shouldPrevent) e.preventDefault();
  }
}, {passive:false});

el.addEventListener('wheel',function(e){
  if(repodUsesFixedFrontView()) return;
  e.preventDefault();
  tRadius=clamp(tRadius*(1+e.deltaY*0.0012),MIN_VIEW_RADIUS,MAX_VIEW_RADIUS);
  interact();
},{passive:false});

el.addEventListener('dblclick',function(e){
  if(repodUsesFixedFrontView()) return;
  e.preventDefault();
  var rect = renderer.domElement.getBoundingClientRect();
  mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
  mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
  raycaster.setFromCamera(mouse, camera);
  var hits = raycaster.intersectObjects(device.children, true);
  var topHit = firstUsableHit(hits);
  if (repodUsesFixedFrontView() && (isVisibleWheelRingHit(topHit) || isTopHitObject(topHit,screen) || isTopHitObject(topHit,centerBtn))) return;
  if(repodUsesMobileControls()){
    if(performance.now()<suppressMobileDblClickUntil) return;
    toggleBodyZoom();
    return;
  }
  tTheta=nearestAngle(theta,TH0); tPhi=PH0; tRadius=R0;
});

/* ================= Top controls ================= */
var btnSpin=document.getElementById('btnSpin');
function goView(t){
  auto=false; if(btnSpin) btnSpin.classList.remove('on');
  tTheta=nearestAngle(theta,t); tPhi=PH0; tRadius=R0;
  notifyRepodModelControlChange();
}
function repodModelControlState(){
  return {
    spinning: !!auto,
    charging: !!charging,
    latchOpen: !!latchOpen
  };
}
function notifyRepodModelControlChange(){
  document.dispatchEvent(new CustomEvent('repod:model-control-change', {
    detail: repodModelControlState()
  }));
}
function setRepodSpin(next){
  auto=typeof next === 'boolean' ? next : !auto;
  if(btnSpin) btnSpin.classList.toggle('on',auto);
  lastInteract=auto ? 0 : performance.now();
  notifyRepodModelControlChange();
}
function setRepodCharging(next){
  charging=typeof next === 'boolean' ? next : !charging;
  if(charging) goView(Math.PI);
  notifyRepodModelControlChange();
}
function setRepodLatch(next){
  latchOpen=typeof next === 'boolean' ? next : !latchOpen;
  goView(Math.PI);
  notifyRepodModelControlChange();
}
var btnFront = document.getElementById('btnFront'); if(btnFront) btnFront.onclick=function(){ goView(0); };
var btnBack = document.getElementById('btnBack'); if(btnBack) btnBack.onclick=function(){ goView(Math.PI); };
if(btnSpin) {
  btnSpin.onclick=function(){
    setRepodSpin();
  };
}
window.repodModelController = {
  front: function(){ goView(0); },
  back: function(){ goView(Math.PI); },
  toggleSpin: function(){ setRepodSpin(); },
  toggleCharge: function(){ setRepodCharging(); },
  toggleLatch: function(){ setRepodLatch(); },
  getState: repodModelControlState
};
document.dispatchEvent(new CustomEvent('repod:model-controller-ready', {
  detail: repodModelControlState()
}));

updateViewRadiusBounds();
